import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";

import App from "./App";
import "./index.scss";
import { PersistGate } from "redux-persist/integration/react";
import LoadingComponent from "./components/LoadingComponent/LoadingComponent";
import store from "./store";
import CognitoToggleComponent from "./components/ToggleComponents/CognitoToggleComponent";

let persistor = persistStore(store);

const renderDefaultComponent = () => {
  return <App></App>;
}

const renderToggledComponent = () => {
  return (
    <div style={{ backgroundColor: '#F8F7F7' }}>
      <App />
    </div>
 )
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={LoadingComponent} persistor={persistor}>
      <CognitoToggleComponent
        studentOnly={true}
        defaultComponent={renderDefaultComponent()}
        toggledComponent={renderToggledComponent()} 
      />
    </PersistGate>
  </Provider>,
  document.querySelector("#root")
);
